import {
  Button,
  Dialog,
  DialogTrigger,
  Popover as RAPopover,
} from "react-aria-components";
import { IconX } from "./icons";

export interface PopoverProps {
  children: React.ReactNode;
  trigger: React.ReactNode;
  placement?: "top" | "bottom" | "left" | "right";
  className?: string;
  /** Called when the dialog opens or closes (react-aria DialogTrigger). */
  onOpenChange?: (isOpen: boolean) => void;
}

export const Popover = ({
  children,
  trigger,
  placement = "top",
  className = "",
  onOpenChange,
}: PopoverProps) => {
  return (
    <DialogTrigger onOpenChange={onOpenChange}>
      <Button className="cursor-pointer">{trigger}</Button>
      <RAPopover placement={placement} offset={10} className={className}>
        <Dialog className="bg-[#E7E8E8] text-black border border-[#E7E8E8] rounded-md px-3 py-2 pr-2 text-sm shadow-[0px_1px_8px_0px_#00000033] outline-none max-w-xs">
          {({ close }) => (
            <div className="flex gap-5">
              <div className="flex-1">{children}</div>
              <button
                type="button"
                onClick={close}
                className="self-start cursor-pointer"
              >
                <IconX variant="sm" />
              </button>
            </div>
          )}
        </Dialog>
      </RAPopover>
    </DialogTrigger>
  );
};
